import { useSelector } from 'react-redux';
import {
  getSelectedCurrency,
  getSelectedCurrencyObject,
  getLocale,
  getCurrencyIncrement,
  getSelectedCurrencySymbol,
} from '@app/redux/currency/selectors';
import type { RootState } from '@app/redux/types';

const useCurrency = () =>
  useSelector((state: RootState) => ({
    currency: getSelectedCurrency(state),
    currencySymbol: getSelectedCurrencySymbol(state),
    currencyObject: getSelectedCurrencyObject(state),
    currencyIncrement: getCurrencyIncrement(state),
    locale: getLocale(state),
  }));

export default useCurrency;
